import React, {
	Component
} from 'react';
import styled from 'styled-components';
import {observer} from 'mobx-react';

import { store } from '../stores/mainStore';

import {debugInfo} from '../network';
import {PreloadAssets} from './PreloadAssets';
import {ProgressBar} from './ProgressBar'
import { integration } from '../integration';
import { Sprite } from './Sprite';
import { preloadB64Images } from './B64Image';

const Bar = styled.div`
	width: 76vw;
	height: 10vw;
	margin-bottom: 7%;
	box-sizing: border-box;
	overflow: hidden;
`

window.debugInfo = debugInfo;

@observer
export class Preloader extends Component {

	state = {
		lobbyLoad: false
	}

	constructor(){
		super();
		integration.postAnalyticsEvent('game_version', 'game_info', store.gameVersion);
		integration.postAnalyticsEvent('preload_start', 'user_experience', Date.now().toString());
	}

	componentDidMount(){
		const imagePaths = ["/assets/lobby/game_lobby_ava.png","/assets/playfield.jpg","/assets/hud/hud_theme_vegas_gold.png","/assets/hud/hud_siu_logo_tiny.png","/assets/hud/hud_icon_star.png","/assets/hud/hud_icon_heart.png","/assets/hud/hud_theme_profile.png","/assets/hud/hud_btn_plus.png","/assets/lobby/lobby_btn_newGame_withText.png","/assets/hud/hud_theme_vegas_blue.png","/assets/lobby/home_panel_blue.png","/assets/lobby/nav_leaderboard_coming_soon.png","/assets/lobby/home_panel_gold.png","/assets/lobby/home_panel_teal.png","/assets/lobby/nav_home.png","/assets/lobby/lobby_nav_bg.png","/assets/lobby/bg.png","/assets/lobby/lobby_nav_mask.png"];

		const onProgress = (percentComplete) => {
			// console.log(event.progress + '%');
			store.reactLoadPercentage = percentComplete;
		}

		preloadB64Images(imagePaths,onProgress);
	}

	render(){
		return (
			<div style={{textAlign: 'center'}}>
				<Sprite w={60} sprite="msg_loading.png" path="/assets/languages/" localize/>
				<Bar>
					<ProgressBar percent={store.totalLoadPercentage}></ProgressBar>
				</Bar>
				<PreloadAssets>
					<img alt="" src='/assets/lobby/lobby_header_bar.png'/>
				</PreloadAssets>
			</div>
		);
	}
}
